<template>
  <div class="editorBlockComponent" ref="eblock"  style="margin: 16px 0;">
    <div ref="pin" class="editorMenu row no-margins">
      <div class="col" v-for="option in formatButtons" v-bind:key="option.title">
        <button :disabled="globalDisabled"
          class="btn-floating btn-smaller transparent z-depth-0 grey-text text-darken-3 waves-effect" @click="
            formatDoc(option.action, `${option.prop ? option.prop : null}`)
            ">
          <span v-html="option.icon"></span>
        </button>
      </div>
      <div class="col" v-if="imageTools">
        <button :disabled="globalDisabled"
          class="btn-floating btn-smaller transparent z-depth-0 grey-text text-darken-3 waves-effect"
          @click="imageEditorState = true">
          <i class="material-icons grey-text text-darken-3">insert_photo</i>
        </button>
      </div>
<!--       <div class="col">
        <button :disabled="globalDisabled" @click="activeCreateTable = true"
          class="btn-floating btn-smaller transparent z-depth-0 grey-text text-darken-3 waves-effect">
          <i class="material-icons grey-text text-darken-3 ">table_chart</i>
        </button>
      </div> -->

      <div class="col s12" v-if="isTable">
        <ul class="flex-menu flex-item  " v-for="(option, i) in tables.menuOptions" v-bind:key="i">
          <ul v-if="option.subMenu" :id="'option'">
            <li v-for="a in option.subMenu" v-bind:key="a">
              <button @click="_tableAction($event, a)" class="grey-text text-darken-3 btn white">
                {{ a }}
              </button>
            </li>
          </ul>
        </ul>
      </div>
    </div>
    <div>
      <div class="row tableCreate" v-if="activeCreateTable">
        <div class="input-field col s s6">
          <input id="tablerows" type="number" class="validate" v-model="tableStructure.numOfRows" />
          <label for="tablerows">Table Rows</label>
        </div>
        <div class="input-field col s6">
          <input id="tablecols" type="number" class="validate" v-model="tableStructure.numOfColumns" />
          <label for="tablecols">Table Columns</label>
        </div>
        <div class="col s12">
          <label>
            <input type="checkbox" v-model="tableStructure.includeHeader" />
            <span>Add table header</span>
          </label>
          <div class="align-right right">
            <button @click="$_cancelTable()" class="btn waves-effect btn-rounded  white black-text">
              Cancel
            </button>
            &nbsp;
            <button @click="_customTableBlock()" :disabled="(tableStructure.numOfRows || tableStructure.numOfColumns) < 1
              " class=" btn waves-effect btn-rounded indigo accent-3 ">
              Create
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="image-menu z-depth-1" v-if="imageMenu" :style="`--data-x:${editMenuPosition.x}px; --data-y:${editMenuPosition.y}px; `
      ">
      <ul class="row">
        <li class="col csi">
          <a href="#" @click.prevent="alignImage('left')" class="transparent grey-text text-darken-2">Left</a>
        </li>
        <li class="col csi">
          <a href="#" @click.prevent="alignImage('right')" class="transparent grey-text text-darken-2">Right</a>
        </li>
        <li class="col csi">
          <a href="#" @click.prevent="imageSize('30%')" class="transparent grey-text text-darken-2">Small</a>
        </li>
        <li class="col csi">
          <a href="#" @click.prevent="imageSize('50%')" class="transparent grey-text text-darken-2">Medium</a>
        </li>
        <li class="col csi">
          <a href="#" @click.prevent="imageSize('80%')" class="transparent grey-text text-darken-2">Large</a>
        </li>
        <li class="col csi">
          <a href="#" @click.prevent="$_removeImage" class="transparent grey-text text-darken-2">Remove</a>
        </li>
      </ul>
    </div>
    <div id="contentEditor" @mouseup="saveSelection" class="htmlContentEditor white" @mousedown="saveSelection"
      @click="$_clearBlankEditor($event)" @paste.prevent="$_pasting" @focus="$_addListners()" @blur="$_addListners()"
      @keydown.tab.exact.prevent="$_tabAction($event, 'indent')"
      @keydown.shift.tab.prevent="$_tabAction($event, 'outdent')" @keyup.delete="$_addListners()"
      :class="userRole === 'subscriber' ? 'grey-text text-lighten-1' : ''"
      :contenteditable="userRole !== 'subscriber' ? true : false" ref="ceditor" @input="_setContent()"></div>
<!--     <editorPhotos @url="$_insertImage" @state="imageEditorState = $event" v-if="imageEditorState" /> -->
  </div>
</template>

<script>
/* import editorPhotos from "@/components/editorPhotos.component"; */
import interact from "interactjs";
import toSingleQuotes from "to-single-quotes";
const editorActions = [
  {
    title: "undo",
    action: "undo",
    icon: `<i class="material-icons">undo</i>`,
  },
  {
    title: "redo",
    action: "redo",
    icon: `<i class="material-icons">redo</i>`,
  },
  {
    title: "Ordered Lists",
    action: "insertOrderedList",
    icon: `<i class="material-icons">format_list_numbered</i>`,
  },
  {
    title: "unOrdred Lists",
    action: "insertUnorderedList",
    icon: `<i class="material-icons">format_list_bulleted</i>`,
  },
  {
    title: "Left Align",
    action: "justifyleft",
    icon: `<i class="material-icons">format_align_left</i>`,
  },
  {
    title: "Center Align",
    action: "justifycenter",
    icon: `<i class="material-icons">format_align_center</i>`,
  },
  {
    title: "Right Align",
    action: "justifyright",
    icon: `<i class="material-icons">format_align_right</i>`,
  },
  {
    title: "Justify Full",
    action: "justifyFull",
    icon: `<i class="material-icons">format_align_justify</i>`,
  },
  {
    title: "bold",
    action: "bold",
    icon: `<i class="material-icons">format_bold</i>`,
  },
  {
    title: "Copy",
    action: "copy",
    icon: `<i class="material-icons">content_copy</i>`,
  },
  {
    title: "Cut",
    action: "cut",
    icon: `<i class="material-icons">content_cut</i>`,
  },
  //{title:'Paste', action:'paste', icon:`<i class="material-icons">content_paste</i>`},
  {
    title: "Remove Formating",
    action: "removeFormat",
    icon: `<i class="material-icons">format_clear</i>`,
  },
  {
    title: "Indent",
    action: "indent",
    icon: `<i class="material-icons">format_indent_increase</i>`,
  },
  {
    title: "Outdent",
    action: "outdent",
    icon: `<i class="material-icons">format_indent_decrease</i>`,
  },
  {
    title: "Quote",
    action: "formatblock",
    prop: "blockquote",
    icon: `<i class="material-icons">format_quote</i>`,
  },
];

const debounce = (func, delay) => {
  let inDebounce;
  return function () {
    const context = this;
    const args = arguments;
    clearTimeout(inDebounce);
    inDebounce = setTimeout(() => func.apply(context, args), delay);
  };
};

const setEndOfContenteditable = (contentEditableElement) => {
  let range, selection;
  if (document.createRange) {
    //Firefox, Chrome, Opera, Safari, IE 9+
    range = document.createRange(); //Create a range (a range is a like the selection but invisible)
    range.selectNodeContents(contentEditableElement); //Select the entire contents of the element with the range
    range.collapse(false); //collapse the range to the end point. false means collapse to end rather than the start
    selection = window.getSelection(); //get the selection object (allows you to change selection)
    selection.removeAllRanges(); //remove any selections already made
    selection.addRange(range); //make the range you have just created the visible selection
  } else if (document.selection) {
    //IE 8 and lower
    range = document.body.createTextRange(); //Create a range (a range is a like the selection but invisible)
    range.moveToElementText(contentEditableElement); //Select the entire contents of the element with the range
    range.collapse(false); //collapse the range to the end point. false means collapse to end rather than the start
    range.select(); //Select the range (make it the visible selection
  }
};

export default {
  name: "blockEditor",
  props: {
    value: {
      type: String,
    },
    content: {
      type: String,
    },
    imageTools: {
      type: Boolean,
      default: false,
    },
  },
  components: {
   // editorPhotos,
  },
  data() {
    return {
      lastTabbedNode: null,
      selectedText: null,
      modal: {
        instance: null,
        options: {},
      },
      tables: {
        lastPosition: "",
        menuOptions: [
          {
            name: "bold",
            icon:
              '<i class="material-icons grey-text text-darken-2">format_bold</i>',
            action: "bold",
          },
          {
            name: "center-align",
            icon:
              '<i class="material-icons grey-text text-darken-2">format_align_center </i>',
            action: "justifycenter",
          },
          {
            name: "left-align",
            icon:
              ' <i class="material-icons grey-text text-darken-2">format_align_left</i>',
            action: "justifyleft",
          },
          {
            name: "right-align",
            icon:
              '<i class="material-icons grey-text text-darken-2">format_align_right</i>',
            action: "justifyright",
          },
          {
            name: "table-options",
            icon: '<i class="material-icons grey-text text-darken-2">add</i>',
            subMenu: [
              "Insert Row Above",
              "Insert Row Below",
              "Insert Column Before",
              "Insert Column After",
              "Remove Row",
              "Remove Column",
            ],
          },
        ],
      },
      activeCreateTable: false,
      tableStructure: {
        numOfRows: null,
        numOfColumns: null,
        includeHeader: false,
      },

      activeEle: null,
      imageMenu: false,
      editMenuPosition: {
        x: 0,
        y: 0,
      },
      imageEditorState: false,
      toolbar: [
        ["bold", "italic", "underline"],
        [{ list: "ordered" }, { list: "bullet" }],
        [
          { align: "" },
          { align: "center" },
          { align: "right" },
          { align: "justify" },
        ],
        [{ list: "ordered" }, { list: "bullet" }, { list: "check" }],
        [{ color: [] }, { background: [] }],
        ["link"],
        ["clean"],
      ],
      globalDisabled: false,
      editor: null,
      ready: false,
      icoPicker: false,
      editorContent: "",
      modalInstance: null,
      formatButtons: editorActions,
      modalOptions: {
        onCloseEnd: () => {
          this.icoPicker = false;
        },
        preventScrolling: false,
      },
    };
  },
  beforeDestroy() { },
  mounted() {
    this.$refs.ceditor.innerHTML = this.content;
    !this.content || this.content === ""
      ? this.$refs.ceditor.setAttribute("data-empty", "true")
      : this.$refs.ceditor.setAttribute("data-empty", "false");
    setTimeout(() => {
      this.ready = true;
      document.execCommand("defaultParagraphSeparator", false, "p");
    }, 300);

    setTimeout(() => {
      this.userRole && this.userRole === 'subscriber'
        ? this.globalDisabled = true
        : false
    }, 500);
  },
  computed: {
    userRole: {
      get() {
        return "user"
        return this.user && this.user.roles.length > 0
          ? this.user.roles[0]
          : false
      }
    },
    isTable: {
      get() {
        return (
          this.tables.lastPosition !== "" &&
          this.tables.lastPosition &&
          this.tables.lastPosition.nodeName === "TD"
        );
      },
    },
    copy: {
      get() {
        return this.content;
      },
      set(value) {
       
      // let reHtml = toSingleQuotes(value);
        /* 		let reObject = {value: reHtml}
         */
        this.$emit("input", value);
        //	this.$store.commit('UPDATE_BLOCK',params)
      },
    },
  },

  methods: {
    imageSize(size) {
      this.activeEle.style.width = size
      this._setContent()
    },
    isElementInViewport(e) {

      var rect = e.getBoundingClientRect();

      return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && /* or $(window).height() */
        rect.right <= (window.innerWidth || document.documentElement.clientWidth) /* or $(window).width() */
      );
    },
    clearActiveOptions() {
      this.imageMenu = false
    },
    _lastPosition(event) {
      this.tables.lastPosition = event.target;
      this.lastTabbedNode = null;
    },
    $_tabAction($event, action) {
      if (!this.isTable) {
        action === "indent"
          ? this.formatDoc("indent", null)
          : this.formatDoc("outdent", null);
      } else {
        let prev = this.tables.lastPosition.previousSibling;
        let next = this.tables.lastPosition.nextSibling;
        if (action === "outdent") {
          /*       let currentNode = prev.nodeName === '#text'
            ?  prev.parentElement
            : prev.nodeName === 'TR'
              ? prev.parentElement.nextSibling
              : prev
              console.log(currentNode) */
          /*   let currentNode = prev.nodeName === '#text'
            ?  prev.parentElement
            : prev.nodeName === 'TR'
              ? prev.parentElement.previousSibling
              : prev
              let toGo = !this.lastTabbedNode
                  ? currentNode.closest('TD')
                  : this.lastTabbedNode.previousSibling && this.lastTabbedNode.previousSibling.nodeName === "TD"
                    ? this.lastTabbedNode.nextSibling
                    : this.lastTabbedNode.closest('TR').previousSibling
                      ? this.lastTabbedNode.closest('TR').previousSibling.childNodes[0]
                       : console.log(this.lastTabbedNode.closest('TR').previousSibling)
              if(toGo) setEndOfContenteditable(toGo)
              this.lastTabbedNode = window.getSelection().anchorNode */
        } else {
          let currentNode =
            next.nodeName === "#text"
              ? next.parentElement
              : next.nodeName === "TR"
                ? next.parentElement.nextSibling
                : next;
          let toGo = !this.lastTabbedNode
            ? currentNode.closest("TD")
            : this.lastTabbedNode.nextSibling &&
              this.lastTabbedNode.nextSibling.nodeName === "TD"
              ? this.lastTabbedNode.nextSibling
              : this.lastTabbedNode.closest("TR").nextSibling
                ? this.lastTabbedNode.closest("TR").nextSibling.childNodes[0]
                : false;
          if (toGo) setEndOfContenteditable(toGo);
          this.lastTabbedNode = window.getSelection().anchorNode;
        }
      }
    },
    $_cancelTable() {
      (this.activeCreateTable = false), (this.tableStructure.numOfRows = null);
      this.tableStructure.numOfColumns = null;
    },
    restoreSelection() {
      let sel;
      if (this.selectedText) {
        if (window.getSelection) {
          sel = window.getSelection();
          sel.removeAllRanges();
          sel.addRange(this.selectedText);
        } else if (document.selection && this.selectedText.select) {
          this.selectedText.select();
        }
      }
    },
    saveSelection() {
      if (window.getSelection) {
        let sel = window.getSelection();
        if (sel.getRangeAt && sel.rangeCount) {
          this.selectedText = sel.getRangeAt(0);
        }
      } else if (document.selection && document.selection.createRange) {
        this.selectedText = document.selection.createRange();
      }
      // this.selectedText = null;
    },
    $_openModal() {
      this.modal.instance.open();
    },
    _tableAction(event, a) {
      if (a == "Insert Row Below" || a == "Insert Row Above") {
        let where = this.tables.lastPosition.parentElement;
        let howManyRows = this.tables.lastPosition.parentElement.cells.length;
        let row = `<tr>${Array(parseInt(howManyRows))
          .join(0)
          .split(0)
          .map((row, i) => `<td data-index="${i}">&nbsp;</td>`)
          .join("")}</tr>`;
        if (a == "Insert Row Below") where.insertAdjacentHTML("afterend", row);
        if (a == "Insert Row Above")
          where.insertAdjacentHTML("beforebegin", row);
      }
      if (a == "Insert Column After") {
        let rows = this.$refs.ceditor.querySelectorAll("tbody tr");
        rows.forEach((element) => {
          let lpv = this.tables.lastPosition.cellIndex + 1;
          element.children[
            this.tables.lastPosition.cellIndex
          ].insertAdjacentHTML("afterend", `<td data-index="${lpv}"></td>`);
        });
        let headingRows = this.$refs.ceditor.querySelectorAll("thead tr");
        headingRows.forEach((element) => {
          element.children[
            this.tables.lastPosition.cellIndex
          ].insertAdjacentHTML("afterend", `<th></th>`);
        });
      }
      if (a == "Insert Column Before") {
        let rows = this.$refs.ceditor.querySelectorAll("tbody tr");
        rows.forEach((element) => {
          element.children[
            this.tables.lastPosition.cellIndex
          ].insertAdjacentHTML(
            "beforebegin",
            `<td data-index="${this.tables.lastPosition.cellIndex + 1}"></td>`
          );
        });
        let headingRows = this.$refs.ceditor.querySelectorAll("thead tr");
        headingRows.forEach((element) => {
          element.children[
            this.tables.lastPosition.cellIndex
          ].insertAdjacentHTML("beforebegin", `<th></th>`);
        });
      }
      if (a === "Remove Row") {
        let where = this.tables.lastPosition.parentElement;
        let howManyRows = this.tables.lastPosition.parentElement.cells.length;
        where.remove();
      }
      if (a === "Remove Column") {
        let where = this.tables.lastPosition;

        let howManyRows = this.tables.lastPosition.parentElement.parentElement.querySelectorAll(
          "tr"
        );
        howManyRows.forEach((cell, index) => {
          let currentCells = cell.querySelectorAll("td");
          currentCells[parseInt(where.attributes["data-index"].value)].remove();
        });
      }
      ///  this.update();
    },

    alignImage(e) {
      let element = this.$el.querySelector("img.active");
      element.style.marginBottom = "12px";
      if (e === "left") {
        element.style.float = "left";
        element.style.marginLeft = "0px";
        element.style.marginRight = "12px";
      } else {
        element.style.float = "right";
        element.style.marginRight = "0px";
        element.style.marginLeft = "12px";
      }
      this._setContent()
    },
    $_removeImage(e) {
      this.activeEle.remove();
      this.activeEle = false;
      this.imageMenu = false;
      this._setContent();
      // this._setContent();
      // this.$el.querySelector("img.active").remove();
    },
    _setContent() {
      this.copy = this.$refs.ceditor.innerHTML || "";
      this.$emit('input', this.$refs.ceditor.innerHTML || "")
    },
    _customTableBlock() {
      let header, row, column;
      header = this.tableStructure.includeHeader;
      row = this.tableStructure.numOfRows;
      column = this.tableStructure.numOfColumns;
      /*   this.$refs.ceditor.focus(); */
      this.restoreSelection();
      let elementClasses = `striped highlight`.toString().replace(/,/g, " ");
      let tableTemplate = `<table class="${elementClasses}" contenteditable="true">${header
        ? `<thead><tr>${Array(parseInt(row))
          .join(0)
          .split(0)
          .map(() => `<th></th>`)
          .join("")} </tr></thead>`
        : ``
        }<tbody>${Array(parseInt(column))
          .join(0)
          .split(0)
          .map(
            () =>
              `<tr> ${Array(parseInt(row))
                .join(0)
                .split(0)
                .map((a, i) => `<td data-index="${i}">&nbsp;</td>`)
                .join("")}</tr>`
          )
          .join("")}</tbody></table>
    `;
      let tempblock = tableTemplate.toString().replace(/' '/g, "");
      document.execCommand("insertHtml", false, tempblock);
      this.$_cancelTable();
    },
    $_clickCapture() {
      this.globalDisabled = true;

      setTimeout(() => {
        this.globalDisabled = false;
      }, 1000);
    },
    $_newContentBlock() {
      this.$_clickCapture();
      const data = {
        acf_fc_layout: "content_block",
        block_alignment: " ",
        classes: "",
        display_size: "col s12 m12 l12",
        content_field: "",
      };
      setTimeout(() => {
        this.$store.commit("ADD_BLOCK", [
          data,
          { parent: this.parentIndex || 0 },
        ]);
      }, 400);
    },
    $_startInteraction(ele) {
      let vm = this;
      interact(ele).resizable({
        edges: { left: false, right: true, bottom: true, top: false },
        listeners: {
          move(event) {
            var target = event.target;
            target.style.width = event.rect.width + "px";
            target.style.height = event.rect.height + "px";
            setTimeout(() => {
              vm.$_addListners();
              vm._setContent()
            }, 100);
          },
        },
        modifiers: [],
        inertia: true,
      });
    },
    $_addListners() {
      return
      let reHtml = toSingleQuotes(this.value);
      this.$emit("content", reHtml);
      this.$emit("input", reHtml);
      this.$emit("update", reHtml);
      /*

    this.$refs.ceditor.addEventListener('click', ()=>{

    }, {passive:true}) */
    },
    $_setTextColor(val) {
      let colorArr = `${val.baseColor}-text ${val.setColor ? "text-" + val.setColor : ""
        }`;
      this.$refs.ceditor.querySelectorAll("p").forEach((element) => {
        element.setAttribute("class", `${colorArr}`);
      });

      this.$refs.ceditor.focus();
      this.copy = this.$refs.ceditor.innerHTML;
    },
    $_activeEditor(status) {
      let removeEditor = () => {
        removeListener();
      };
      let removeListener = () => {
        document
          .querySelector(".activeEditor")
          .parentElement.parentElement.removeEventListener(
            "focusout",
            removeEditor,
            { passive: true }
          );
        setTimeout(() => {
          this.$el.classList.remove("activeEditor");
        }, 400);
      };

      if (status) {
        this.$el.classList.add("activeEditor");
      } else {
        document
          .querySelector(".activeEditor")
          .parentElement.parentElement.addEventListener(
            "focusout",
            removeEditor,
            { passive: true }
          );
      }
    },
    $_clearBlankEditor(e) {
      this._lastPosition(e);

      if (e.target.nodeName === "IMG") {
        e.preventDefault();
        let position = e.target.getClientRects();
        this.editMenuPosition = {
          x: position[0].left,
          y: position[0].bottom,
          w: position[0].width,
        };
        e.target.classList.add("active");
        this.ShowImgeMenu(e.target);
        this.$_startInteraction(e.target);

        const ifTrueDo = () => {
          if (!this.isElementInViewport(e.target)) {
            this.imageMenu = false
            window.removeEventListener('scroll', ifTrueDo)
          }
        }
        setTimeout(() => {
          window.addEventListener('scroll', ifTrueDo)
        }, 100);
      } else {
        this.activeEle = false;
        this.imageMenu = false;
        this.$el
          .querySelectorAll("img.active")
          .forEach((x) => x.classList.remove("active"));
      }
      if (this.$refs.ceditor.innerHTML == "") {
        this.$refs.ceditor.setAttribute("data-empty", "false");
        document.execCommand("insertHTML", false, `<p>&nbsp;</p>`);
        setTimeout(() => {
          this.$refs.ceditor.querySelector("p").focus();
        }, 50);
      }
    },
    ShowImgeMenu(img) {
      this.activeEle = img;
      this.imageMenu = true;
    },
    $_insertImage(url) {
      //log(url)
      //  const url = window.prompt('URL')

      if (url) {
        let DIV = document.createElement("DIV");
        let IMG = document.createElement("IMG");
        DIV.setAttribute("contenteditable", "false");
        IMG.setAttribute("src", url);
        IMG.setAttribute("draggable", false);
        DIV.append(IMG);

        this.restoreSelection();
        //this.$refs.ceditor.focus();
        //setEndOfContenteditable(this.$refs.ceditor);

        setTimeout(() => {
          document.execCommand("insertHTML", false, DIV.innerHTML);
          this._setContent()
        });
      }
    },
    formatDoc(sCmd, sValue) {
      this.$refs.ceditor.focus();
      if (sCmd == "paste") {
        document.execCommand(
          "insertHTML",
          false,
          event.clipboardData.getData("text/plain")
        );
      } else {
        document.execCommand(sCmd, false, sValue);
      }
      this.$_addListners();
    },
    $_pasting(event) {
      const removeStyles = (el) => {
        let nV = el;
        nV.removeAttribute("style");
        nV.removeAttribute("class");
        if (nV.childNodes.length > 0) {
          for (let child in nV.childNodes) {
            /* filter element nodes only */
            if (nV.childNodes[child].nodeType == 1)
              removeStyles(nV.childNodes[child]);
          }
        }
        return nV;
      };

      //	document.execCommand("insertHTML", false, event.clipboardData.getData('text/plain'))
      if (event.clipboardData.items.length > 1) {
        let items = event.clipboardData.items;
        for (let i in items) {
          let item = items[i];
          if (item.kind === "file") {
            let blob = item.getAsFile();

            let URLObj = window.URL || window.webkitURL;
            let source = URLObj.createObjectURL(blob);
            let pastedImage = new Image();
            pastedImage.src = source;
            let DIV = document.createElement("DIV");
            DIV.innerHTML = DIV.innerHTML + pastedImage.outerHTML;
            document.execCommand("insertHTML", false, DIV.innerHTML);
          } else {
            /*     let DIV = document.createElement("DIV");
            DIV.innerHTML = event.clipboardData.getData("text/plain");
            document.execCommand("insertHTML", false, DIV.textContent); */
            let DIV = document.createElement("DIV");
            DIV.innerHTML = event.clipboardData
              .getData("text/html")
              .replace(/<\!--.*?-->/g, "");
            document.execCommand(
              "insertHTML",
              false,
              removeStyles(DIV).innerHTML
            );

            break;
          }
        }
      } else {
        let DIV = document.createElement("DIV");
        DIV.innerHTML = event.clipboardData
          .getData("text/html")
          .replace(/<\!--.*?-->/g, "");
        document.execCommand("insertHTML", false, removeStyles(DIV).innerHTML);
      }
      setTimeout(() => {
        this.$_addListners();
      }, 100);
    },
    $_insertIcon(value) {
      this.modalInstance.close();
      this.$refs.ceditor.focus();
      document.execCommand(
        "insertHTML",
        false,
        `<span>${value.iconHTML}</span> &nbsp;`
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.tableCreate {
  margin-bottom: 0px;
}

#contentEditor {
  min-height: 80px;
  margin: 8px;
  position: relative;
  padding: 16px;
  z-index: 1;
  border: 1px solid rgba(0, 0, 0, 0.2);
}

#icons {
  min-height: 60%;

  .modal-content {
    //  position: relative !important ;
    overflow-x: hidden;
  }
}

.editorBlockComponent {
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 5px;
  overflow: hidden;
  position: relative;
}
</style>
<style lang="scss">
table {
  td {
    // border: 1px solid lightgray;
  }
}

.editorBlockComponent {

  table td,
  table th {
    border: 1px solid #cacaca !important;
  }
}

.editorMenu {
  background: rgba(0, 0, 0, 0.04);
  padding: 8px;

  .col {
    padding: 0 3px;
  }

  button {
    &.btn-floating {
      span {
        i {
          font-size: 22px;
          color: inherit !important;
        }
      }
    }
  }

  .flex-menu {
    margin: 12px 0;

    ul {
      margin: 0;
      display: flex;
      flex-wrap: wrap;

      li {
        list-style-type: none !important;
        margin: 6px;
      }
    }
  }
}

.image-menu {
  position: fixed;
  /*   max-width: 450px; */
  min-width: 240px;
  background: #ffffff;
  z-index: 99;
  padding: 5px;
  width: var(--data-w);
  left: var(--data-x);
  top: var(--data-y);

  .row {
    display: flex;
    margin: 0px;

    .col.csi {
      list-style-type: none !important;
      list-style: none !important;
      font-size: 12px;
    }
  }
}

#contentEditor[data-empty="true"]:before {
  content: "Type Here";
  text-align: center;
  width: 100%;
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  line-height: 72px;
  background-color: rgba(255, 255, 255, 0.8);
  text-transform: uppercase;
  font-size: 21px;
  font-weight: 300;
  font-family: "Noto Serif", Georgia, "Times New Roman", Times, serif;
  opacity: 0.4;
  z-index: -1;
}

.htmlContentEditor {
  display: flow-root;

  img {
    max-width: 80%;
  }

  ul {
    margin-left: 36px;
    list-style-type: disc !important;

    li {
      list-style-type: disc !important;
    }
  }
}

.editorBlockComponent {
  img {
    height: auto !important;

    //	pointer-events: none !important;
    &.active {
      border: 1.4px solid blue;
      cursor: sw-resize;
      -webkit-touch-callout: none;
      /* iOS Safari */
      -webkit-user-select: none;
      /* Safari */
      -khtml-user-select: none;
      /* Konqueror HTML */
      -moz-user-select: none;
      /* Old versions of Firefox */
      -ms-user-select: none;
      /* Internet Explorer/Edge */
      user-select: none;
      /* Non-prefixed version, currently
                                  supported by Chrome, Edge, Opera and Firefox */
    }
  }
}
</style>
